window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.walletRepo = function () {
    var url = 'api/wallet';

    var create = function (iznos, naCasino, moreData) {

        moreData = moreData || {};


        return fetch(url, {
                method: 'POST',
                credentials: repos.base.credentials,
                headers: repos.base.headers(),
                body: JSON.stringify(Object.assign(moreData, {
                    iznos: iznos,
                    naCasino: naCasino,
                }))
            })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        create: create
    }

}();